import { projectPlanningService } from 'hq/services';
import { useInfiniteQuery } from 'react-query';
import { FirstParamOfFn } from '@types';
import { QUERY_KEYS } from 'api/query-keys';

const useGetProjectPlanningProjects = (
  params: FirstParamOfFn<typeof projectPlanningService.getProjectPlanningProjects>
) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.projectPlanningProjectsFilters(params),
    queryFn: async ({ pageParam = 0 }) =>
      await projectPlanningService.getProjectPlanningProjects({
        pageParam,
        toDate: params.toDate,
        pageSizeParam: params.pageSizeParam,
        company: params.company,
        branchOfficeIds: params.branchOfficeIds,
        departmentIds: params.departmentIds,
        jobType: params.jobType,
        filledStatus: params.filledStatus,
        isFreelance: params.isFreelance,
        isTempWork: params.isTempWork,
        areFreelanceApplications: params.areFreelanceApplications,
        areTempworkApplications: params.areTempworkApplications,
        areNoApplications: params.areNoApplications,
      }),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
export { useGetProjectPlanningProjects };
